const isNumberInput = (element) => {
    return (!!element &&
        element.tagName === "INPUT" &&
        element.type === "number");
};
export const registerPreventNumberWheel = () => {
    const handleWheel = (event) => {
        const activeElement = document.activeElement;
        if (isNumberInput(activeElement) && activeElement === document.activeElement) {
            event.preventDefault();
        }
    };
    document.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
        document.removeEventListener("wheel", handleWheel);
    };
};
